import RafThrottle from '@utilities/raf-throttle';

const SCROLLED_CLASS = 'sticky-bar--is-scrolled';
const HIDDEN_CLASS = 'sticky-bar--is-hidden';
const PAGE_TITLE_HOOK = '[js-hook-page-title]';
const FOOTER_HOOK = '[js-hook-footer]';

class stickyApplyBar {
    constructor(element) {
        this.element = element;
        this.pageTitle = document.querySelector(PAGE_TITLE_HOOK);
        this.footer = document.querySelector(FOOTER_HOOK);

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        RafThrottle.set([
            {
                element: window,
                event: 'scroll',
                namespace: 'checkSickyBar',
                fn: () => this.checkStickyBarState(),
            },
        ]);
    }

    checkStickyBarState() {
        const pageTitleScrollPos = this.pageTitle.getBoundingClientRect().bottom;
        const footerScrollPos = this.footer.getBoundingClientRect().top;

        if (footerScrollPos < window.innerHeight) {
            this.element.classList.add(HIDDEN_CLASS);
        } else if (pageTitleScrollPos < 20) {
            this.element.classList.remove(HIDDEN_CLASS);
            this.element.classList.add(SCROLLED_CLASS);
        } else {
            this.element.classList.remove(SCROLLED_CLASS);
            this.element.classList.remove(HIDDEN_CLASS);
        }
    }
}

export default stickyApplyBar;
